var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoaderWrapper',[_c('div',{staticClass:"header context"},[_c('h1',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.$t('drive.edit_category.header')))])]),_c('Header'),_c('FolderForm',{attrs:{"folder":_vm.newCategory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }